const SALES_ROUTES = {
  path: '/sales',
  component: () => import('@/pages/Sales/SalesPagesContainer.vue'),
  children: [
    {
      path: '',
      name: 'sales.index',
      component: () => import('@/pages/Sales/SalesPage.vue'),
    },
    {
      path: ':id',
      name: 'sales.show',
      component: () => import('@/pages/Sales/SaleShowPage.vue'),
    },
  ],
};

export default SALES_ROUTES;
